import React, { useEffect, useState } from "react";
import { Layout, Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useParams, useLocation } from "react-router-dom";
import { message, Tag, Space, Segmented } from "antd";
import CalenderComponent from "./components/Calender";
import ListView from "./components/ListView";
import EventModal from "./components/EventModal";
import OrdersList from "../../components/scheduling/OrdersList";
import SingleEventsModal from "./components/SingleEventsModal";
import OverlappingEventsModal from "./components/OverlappingEventsModal";
import GenerateDateModal from "./components/GenerateDateModal";
import ModalCloseButton from "./components/ModalCloseButton";
import CustomEvent from "./components/CustomEvent";
import PatientDetails from "./components/PatientDetails";
import _ from "lodash";
import { useMedia } from "react-media";
import {
  convertPlanEventFromCalender,
  comparePlanWithSilmulation,
  isAllowedOverlapping,
  isNotAvailablePlanEventHours,
  getFullName,
} from "../../components/util/helpers";
import { loadRecord } from "../patientDetails/patientDetailsSlice";
import FloatingButton from "../../components/util/FloatingButton";
import { useIntl } from "react-intl";
import {
  setActiveEvent,
  changeEmployee,
  setActivePlan,
  updatePlan,
  simulatePlan,
  loadPlan,
  setModalMode,
  reset,
} from "./PlanSlice";
import { useDispatch, useSelector } from "react-redux";
import AnimationWrapper from "../../components/animations/AnimationWrapper";
import { useIsMount } from "../../hooks";
const { Header, Content } = Layout;

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};

const useModal = (initialVisibility) => {
  const [isVisible, setIsVisible] = useState(initialVisibility);

  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);

  return {
    isVisible,
    show,
    hide,
  };
};

const Plan = (props) => {
  const { closeModal } = props;
  const intl = useIntl();
  const isfirstRender = useIsMount();
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const [modal, contextHolder] = Modal.useModal();
  let { branchId, id } = useParams();
  let location = useLocation();
  const calenderViewTxt = intl.formatMessage({
    id: "app.plans.calenderViewTxt",
  });
  const listViewTxt = intl.formatMessage({
    id: "app.plans.listViewTxt",
  });
  const [activeEventDay, setActiveEventDay] = useState(null);
  const [originalActiveEvent, setOriginalActiveEvent] = useState(null);
  const [mode, setMode] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [changed, setChanged] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [view, setView] = useState(calenderViewTxt);
  const [allowedOverlapping, setAllowedOverlapping] = useState(null);
  const [hasSchedulledEmployees, setHasSchedulledEmployees] = useState();
  const dispatch = useDispatch();
  const activeEvent = useSelector((state) => state.plan.activeEvent);
  const activePlan = useSelector((state) => state.plan.activePlan);
  const activeSimulatedPlan = useSelector(
    (state) => state.plan.activeSimulatedPlan
  );
  const effective_orders =
    activeSimulatedPlan.effective_orders || activePlan.effective_orders;
  const order_time_extractions =
    activeSimulatedPlan.order_time_extractions ||
    activePlan.order_time_extractions;
  const allowHoursOverloading = useSelector(
    (state) => state.organization.details.allow_hours_overloading
  );
  const serverPlan = useSelector((state) => state.plan.serverPlan);
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const updateLoading = useSelector(
    (state) => state.pendingActions["plan/update"]
  );

  const eventModal = useModal(false);
  const singleEventsModal = useModal(false);
  const overlappingEventsModal = useModal(false);
  const generateModal = useModal(false);

  const onViewChange = (val) => {
    setView(val);
  };

  useEffect(() => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      patientId: id,
      admin: isAdmin,
      branchId: branchId,
    };
    setFirstLoad(true);
    dispatch(reset());
    dispatch(loadPlan(params));
    return function cleanup() {
      dispatch(reset());
      setFirstLoad(false);
    };
  }, [dispatch]);

  useEffect(() => {
    if (!firstLoad && !isfirstRender) {
      const params = getSimulateParams();
      dispatch(simulatePlan(params));
    } else if (firstLoad) {
      setFirstLoad(false);
    }
    const isEqual = comparePlanWithSilmulation(activePlan, serverPlan);
    setChanged(!isEqual);
  }, [activePlan, activePatient, serverPlan, dispatch]);

  useEffect(() => {
    const schedulled =
      activePlan.recurrent_events.filter((i) => i.employee_id !== null).length >
      0;
    setHasSchedulledEmployees(schedulled);
  }, [activePlan]);

  const getSimulateParams = () => {
    const filteredEvents = activePlan.recurrent_events.filter(
      (item) => item.order !== undefined
    );
    const params = {
      branchId: activePatient.branch,
      id: activePatient.id,
      work_plan: { ...activePlan, recurrent_events: filteredEvents },
    };
    return params;
  };

  useEffect(() => {
    if (!eventModal.isVisible) {
      let arr = [];

      activePlan["recurrent_events"].forEach((item, i) => {
        arr.push({ ...item, duplicated: null, duplicateWeekdays: null });
      });
      dispatch(setActivePlan({ ...activePlan, recurrent_events: arr }));
      dispatch(setActiveEvent(null));
    }
  }, [eventModal.isVisible]);

  useEffect(() => {
    if (activeEvent) {
      const changedEvent = { ...activeEvent };
      delete changedEvent.start;
      delete changedEvent.end;
      const index = activePlan["recurrent_events"].findIndex(
        (item) => item.id === activeEvent.id
      );
      const arr = [...activePlan["recurrent_events"]];
      arr.splice(index, 1, {
        ...changedEvent,
      });
      dispatch(setActivePlan({ ...activePlan, recurrent_events: arr }));
    }
  }, [activeEvent]);

  const onGenerate = () => {
    generateModal.show();
  };
  const changeEvent = (changed, start, end) => {
    const changedEvent = {
      ...changed,
      start,
      end,
    };
    const converted = convertPlanEventFromCalender(changedEvent);
    const nextEvents = activePlan["recurrent_events"].map((existingEvent) => {
      return existingEvent.id === converted.id ? converted : existingEvent;
    });
    dispatch(setActivePlan({ ...activePlan, recurrent_events: nextEvents }));
  };

  const createEvent = (newEvent) => {
    const newId = activePlan["recurrent_events"].reduce(
      (a, b) => 1 + a + b.id,
      0
    );
    newEvent["id"] = newId;
    const converted = convertPlanEventFromCalender(newEvent);
    const nextEvents = activePlan["recurrent_events"].concat([converted]);
    dispatch(setActivePlan({ ...activePlan, recurrent_events: nextEvents }));
    dispatch(setActiveEvent(converted));
    setActiveEventDay(converted.weekday);
    setMode("new");
    dispatch(setModalMode("new"));
    eventModal.show();
  };

  const editEvent = (newEvent) => {
    const converted = convertPlanEventFromCalender(newEvent);
    dispatch(setActiveEvent(converted));
    setOriginalActiveEvent(newEvent);
    setActiveEventDay(converted.weekday);
    eventModal.show();
    setMode("edit");
  };

  const submitEvent = (e) => {
    const isNotAvailable = isNotAvailablePlanEventHours(
      activeEvent.employee,
      activePatient,
      activeEvent.start,
      activeEvent.end,
      message,
      intl
    );
    if (isNotAvailable) {
      handleCancel();
    } else {
      eventModal.hide();
    }
    dispatch(setModalMode(null));
  };

  const handleCancel = (e) => {
    eventModal.hide();
    const index = activePlan["recurrent_events"].findIndex(
      (item) => item.id === activeEvent.id
    );
    const restored = [...activePlan["recurrent_events"]];
    restored.splice(index, 1, {
      ...originalActiveEvent,
    });

    const filtered = activePlan["recurrent_events"].filter(
      (item) => item.id !== activeEvent.id
    );
    const arr = mode === "new" ? filtered : restored;
    dispatch(setActivePlan({ ...activePlan, recurrent_events: arr }));
    dispatch(setModalMode(null));
  };

  const removeEvent = (e) => {
    eventModal.hide();
    const arr = activePlan["recurrent_events"].filter(
      (item) => item.id !== activeEvent.id
    );
    dispatch(setActivePlan({ ...activePlan, recurrent_events: arr }));
  };

  const onUpdatePlan = async () => {
    confirmContinueWithConflicts();
  };

  const confirmContinueWithConflicts = () => {
    const title = intl.formatMessage({
      id: "app.plans.continueWithConflictsTitle",
    });
    const content = intl.formatMessage({
      id: "app.plans.continueWithConflictsContent",
    });
    if (
      activeSimulatedPlan.conflict_events &&
      activeSimulatedPlan.conflict_events.length > 0
    ) {
      modal.confirm({
        title: title,
        icon: <ExclamationCircleOutlined />,
        content: content,
        onOk() {
          return confirmContinueWithSingleEvents();
        },
        onCancel() {},
      });
    } else {
      confirmContinueWithSingleEvents();
    }
  };

  const confirmContinueWithSingleEvents = () => {
    if (
      activeSimulatedPlan.single_events &&
      activeSimulatedPlan.single_events.length > 0
    ) {
      singleEventsModal.show();
    } else {
      confirmContinueWithOverLappingEvents();
    }
  };

  const confirmContinueWithOverLappingEvents = () => {
    const overlappedEvents = activeSimulatedPlan.overlapped_recurrent_events;
    if (overlappedEvents && overlappedEvents.length > 0) {
      const isAllowed =
        isAllowedOverlapping(activeSimulatedPlan.overlapped_recurrent_events) ||
        allowHoursOverloading;
      setAllowedOverlapping(isAllowed);
      overlappingEventsModal.show();
    } else {
      onSaveConfirmed();
    }
  };
  const onSaveConfirmed = () => {
    generateModal.show();
  };

  const savePlan = async (generateDates, selected) => {
    const grouped = _.groupBy(activePlan.recurrent_events, "order_id");
    const plans = Object.keys(grouped).map((key) => ({
      order_id: +key,
      recurrent_events: grouped[key],
    }));
    //check if there are orders with no recurrent events
    activePlan.effective_orders.forEach((item, i) => {
      const found = plans.filter((j) => j.order_id === item.id)[0];
      if (!found) {
        plans.push({
          order_id: +item.id,
          recurrent_events: [],
        });
      }
    });
    let changedPlans = [];
    plans.forEach((item, i) => {
      const isSelected = selected
        ? selected.find((j) => j === item.order_id)
        : null;

      // If there are changes, we generate events with custom start dates for the selected orders
      if (isSelected) {
        const orderGenerateDates = generateDates.find(
          (k) => k.order_id === item.order_id
        );
        const generatedFrom = orderGenerateDates?.generated_from;
        if (generatedFrom) {
          changedPlans.push({
            ...item,
            generated_from: generatedFrom.format(),
          });
        } else {
          console.warn(
            `No matching generated_from found for order_id: ${item.order_id}`
          );
        }
      }
    });

    const params = {
      branchId: activePatient.branch,
      id: activePatient.id,
      work_plan: { plans: selected ? changedPlans : plans },
    };
    const action = await dispatch(updatePlan(params));
    if (!action.error) {
      getPatient(activePatient.id);
      closeModal();
    }
  };

  const getPatient = (id) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: activePatient.branch,
      admin: isAdmin,
    };
    dispatch(loadRecord(params));
  };

  const onFilterOrdersChanged = (orderId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== orderId)
      : [...filteredOrders, orderId];
    setFilteredOrders(newFiltered);
  };

  const onChosenEmployee = (employee) => {
    const client_salary_tariff_id =
      activeEvent?.order?.client?.salary_tariff_id;
    const employeeName = employee
      ? getFullName(employee["surename"], employee["first_name"])
      : "";
    dispatch(
      setActiveEvent({
        ...activeEvent,
        employee: employee,
        employee_id: employee.id,
        employeeName: employeeName,
        title: employeeName,
        tariff_id: client_salary_tariff_id || employee.tariff_id,
        use_employee_tariff:
          client_salary_tariff_id || employee?.tariff ? true : false,
        oncall: false,
      })
    );
  };

  const onRemoveEmployee = () => {
    dispatch(
      setActiveEvent({
        ...activeEvent,
        employee: null,
        employee_id: null,
        tariff_id: null,
        employeeName: null,
        title: null,
      })
    );
  };

  const onTariffChanged = (val) => {
    dispatch(
      setActiveEvent({
        ...activeEvent,
        tariff_id: val,
      })
    );
  };

  const onUseEmployeeTariffChanged = (val) => {
    const clientTariffId = activeEvent?.order?.client?.salary_tariff_id;
    dispatch(
      setActiveEvent({
        ...activeEvent,
        use_employee_tariff: val,
        tariff_id: clientTariffId || activeEvent?.employee?.tariff?.id,
      })
    );
  };

  const onTransportationChanged = (val) => {
    dispatch(
      setActiveEvent({
        ...activeEvent,
        transportation_cost: val,
      })
    );
  };

  const replaceEmployee = (employee, eventsIds) => {
    if (eventsIds && eventsIds.length > 0) {
      eventsIds.forEach((eventId) =>
        dispatch(changeEmployee({ employee, eventId }))
      );
    }
  };

  const social_security = "ביטוח לאומי";
  const holocast_survivors_fund = "הקרן לנפגעי שואה";
  const ministry_of_defence = "משרד הביטחון";

  const ordersPalette = {
    [social_security]: "#53C31A",
    [holocast_survivors_fund]: "#F99646",
    [ministry_of_defence]: "#6C64FE",
  };

  const ordersBorderPalette = {
    [social_security]: "#C8D7C2",
    [holocast_survivors_fund]: "#F6BD8D",
    [ministry_of_defence]: "#D8D6FC",
  };

  const ordersBgPalette = {
    [social_security]: "#F1FBEE",
    [holocast_survivors_fund]: "#FDEEE0",
    [ministry_of_defence]: "#F2EFFF",
  };

  var allTimeExtractions = [];
  for (var key in order_time_extractions) {
    allTimeExtractions.push(order_time_extractions[key]);
  }

  const total =
    allTimeExtractions &&
    Math.round(
      (allTimeExtractions.reduce((a, b) => +a + +b.planned_weekly_minutes, 0) /
        60) *
        100
    ) / 100;

  return (
    <Layout style={{ background: "transparent" }}>
      {contextHolder}
      <AnimationWrapper animation="fadeIn" duration={0.8}>
        <ModalCloseButton closeModal={closeModal} />
        <div
          style={{
            display: "flex",
            gap: "20px",
            width: "100%",
            paddingBottom: "10px",
          }}
        >
          <div
            style={{
              width: "200px",
              flexShrink: 0,
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Space size="middle">
              <Button
                onClick={onGenerate}
                type="primary"
                disabled={!hasSchedulledEmployees || changed}
              >
                {intl.formatMessage({
                  id: "app.actions.generatePlanEvents",
                })}
              </Button>
              {total && (
                <Tag style={{ margin: 0 }}>
                  {`${total} ${intl.formatMessage({
                    id: "app.scheduling.totalSceduledHours",
                  })}`}
                </Tag>
              )}
            </Space>
          </div>

          <Header
            style={{
              background: "transparent",
              display: "flex",
              height: "auto",
              justifyContent: "center",
              minHeight: "80px",
              padding: 0,
              flex: 1,
            }}
          >
            <FloatingButton
              resource={"patients"}
              action={"editor"}
              mode={mode}
              saveLoading={updateLoading}
              saveText={intl.formatMessage({
                id: "app.actions.updatePlan",
              })}
              show={changed}
              onSubmit={onUpdatePlan}
            />
            <OrdersList
              effective_orders={effective_orders?.filter(
                (j) => !j?.order_service_type?.supporting_community
              )}
              order_time_extractions={order_time_extractions}
              ordersPalette={ordersPalette}
              onFilterOrdersChanged={onFilterOrdersChanged}
              filteredOrders={filteredOrders}
            />
          </Header>

          <div
            style={{
              minWidth: "250px",
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-end",
              height: "90px",
            }}
          >
            {matches.small ? null : (
              <div>
                <PatientDetails record={activePatient} />
              </div>
            )}
            <Segmented
              options={[calenderViewTxt, listViewTxt]}
              onChange={onViewChange}
            />
          </div>
        </div>
        <Content style={{ background: "transparent" }}>
          {view === calenderViewTxt ? (
            <CalenderComponent
              filteredOrders={filteredOrders}
              ordersBgPalette={ordersBgPalette}
              ordersBorderPalette={ordersBorderPalette}
              effective_orders={effective_orders}
              changeEvent={changeEvent}
              createEvent={createEvent}
              editEvent={editEvent}
              activePlan={activePlan}
              customEvent={(prop) => (
                <CustomEvent event={prop.event} ordersPalette={ordersPalette} />
              )}
              activePatient={activePatient}
              intl={intl}
            />
          ) : (
            <ListView
              filteredOrders={filteredOrders}
              activePlan={activePlan}
              onEdit={editEvent}
              activePatient={activePatient}
              replaceEmployee={replaceEmployee}
            />
          )}
        </Content>
        <EventModal
          orders={effective_orders}
          order_time_extractions={order_time_extractions}
          ordersPalette={ordersPalette}
          ordersBgPalette={ordersBgPalette}
          activeEvent={activeEvent}
          activeEventDay={activeEventDay}
          // visible={visible}
          visible={eventModal.isVisible}
          // handleCancel={eventModal.hide}
          submitEvent={submitEvent}
          handleCancel={handleCancel}
          removeEvent={removeEvent}
          mode={mode}
          onChosenEmployee={onChosenEmployee}
          onRemoveEmployee={onRemoveEmployee}
          onTariffChanged={onTariffChanged}
          onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
          onTransportationChanged={onTransportationChanged}
          originalEmployeeId={
            originalActiveEvent && originalActiveEvent.employee_id
          }
          patient={activePatient}
        />
        <SingleEventsModal
          visible={singleEventsModal.isVisible}
          handleCancel={singleEventsModal.hide}
          handleContinue={confirmContinueWithOverLappingEvents}
        />
        <OverlappingEventsModal
          visible={overlappingEventsModal.isVisible}
          handleCancel={overlappingEventsModal.hide}
          handleContinue={onSaveConfirmed}
          allowedOverlapping={allowedOverlapping}
        />
        <GenerateDateModal
          visible={generateModal.isVisible}
          handleCancel={generateModal.hide}
          handleContinue={savePlan}
        />
      </AnimationWrapper>
    </Layout>
  );
};

export default Plan;
